import { classNames } from '../../lib/utils'

export default function Input({
  label,
  error,
  className = '',
  type = 'text',
  id,
  ...props
}) {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-')

  return (
    <div className={classNames('flex flex-col gap-1.5', className)}>
      {label && (
        <label htmlFor={inputId} className="text-[0.6875rem] font-semibold tracking-[0.08em] uppercase text-on-surface-variant">
          {label}
        </label>
      )}
      <input
        id={inputId}
        type={type}
        className={classNames(
          'w-full px-3.5 py-3 rounded-md bg-surface-container-highest text-on-surface text-sm font-body',
          'ghost-border outline-none transition-all duration-150',
          'focus:bg-surface-container-lowest focus:border-b-2 focus:border-b-primary focus:shadow-[0_0_0_4px_rgba(0,101,101,0.1)]',
          'placeholder:text-outline',
          error && 'border-error',
          type === 'number' && 'font-mono'
        )}
        {...props}
      />
      {error && <p className="text-xs text-error">{error}</p>}
    </div>
  )
}
